import { render, staticRenderFns } from "./InfoCell.vue?vue&type=template&id=75a64856&scoped=true&"
import script from "./InfoCell.vue?vue&type=script&lang=js&"
export * from "./InfoCell.vue?vue&type=script&lang=js&"
import style0 from "./InfoCell.vue?vue&type=style&index=0&id=75a64856&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a64856",
  null
  
)

export default component.exports